import FieldType from '../../../components/Form/Fields/type'
import { length, lengthRequired, birthYear, phoneRequired, emailRequired, passwordRequired, phone } from '@polvo-labs/form-utils'
import Avatar from '../../../components/Form/Fields/Avatar'
import Select from '../../../components/Form/Fields/Select'
import Password from '../../../components/Form/Fields/Password'
import { cpfCnpjRequiredValidation } from '../../../utils/form-validations'

export interface UserCreateFormData {
  avatar: { id: number, url: string }
  name: string
  email: string
  city: string
  phone: string
  cpf: string
  birth_year: string
  profession: string
  gender: string
  password: string
}

export type UserCreateForm = keyof UserCreateFormData

const fields: FieldType<UserCreateForm>[] = [
  {
    name: 'avatar',
    data: {},
    html: {},
    component: Avatar,
  },
  {
    name: 'name',
    data: {
      icon: 'text',
      label: 'Nome completo *',
    },
    html: {
      maxLength: 100,
      placeholder: 'Nome e sobrenome',
    },
    validation: lengthRequired({ min: 1, max: 100 }),
  },
  {
    name: 'email',
    data: {
      icon: 'text',
      label: 'Email *',
    },
    html: {
      maxLength: 255,
      placeholder: 'nome@nome.com.br',
    },
    validation: emailRequired,
  },
  // {
  //   name: 'city',
  //   data: {
  //     icon: 'geolocation',
  //     label: 'Cidade atual',
  //   },
  //   html: {
  //     maxLength: 30,
  //     placeholder: 'Onde você mora?',
  //   },
  //   validation: length({ min: 1, max: 30 }),
  // },
  // {
  //   name: 'phone',
  //   data: {
  //     icon: 'phone',
  //     label: 'Telefone *',
  //   },
  //   html: {
  //     maxLength: 15,
  //     placeholder: '(xx) xxxxx-xxxx',
  //   },
  //   validation: phone,
  // },
  {
    name: 'cpf',
    data: {
      icon: 'cpf',
      label: 'CPF',
    },
    html: {
      maxLength: 18,
      placeholder: 'Informe seu CPF',
    },
    validation: cpfCnpjRequiredValidation,
  },
  // {
  //   name: 'birth_year',
  //   data: {
  //     icon: 'calendar',
  //     label: 'Ano de nascimento',
  //   },
  //   html: {
  //     maxLength: 4,
  //     pattern: '\\d\\d\\d\\d',
  //     placeholder: 'Em que ano você nasceu?',
  //   },
  //   validation: birthYear,
  // },
  // {
  //   name: 'profession',
  //   data: {
  //     icon: 'profession',
  //     label: 'Profissão',
  //   },
  //   html: {
  //     maxLength: 100,
  //     placeholder: 'Qual a sua profissão?',
  //   },
  //   validation: length({ min: 1, max: 100 }),
  // },
  // {
  //   name: 'gender',
  //   component: Select,
  //   data: {
  //     label: 'Gênero',
  //     icon: 'gender',
  //     options: [
  //       {
  //         label: 'Informe seu gênero',
  //         value: '',
  //       },
  //       {
  //         label: 'Homem',
  //         value: 'MALE',
  //       },
  //       {
  //         label: 'Mulher',
  //         value: 'FEMALE',
  //       },
  //       {
  //         label: 'Não informado',
  //         value: 'NOT_INFORMED',
  //       },
  //       {
  //         label: 'Outro',
  //         value: 'OTHER',
  //       },
  //     ],
  //   },
  //   html: {},
  // },
  {
    name: 'password',
    component: Password,
    data: {
      icon: 'password',
      label: 'Senha',
    },
    html: {
      maxLength: 255,
      placeholder: 'Digite a senha do novo usuário',
    },
    validation: passwordRequired,
  },
]

export default fields
